/**
 * File Name          : publisher.model.ts
 * Author             : Jared Laine Dyreson
 * Version            : 0.0.0
 * Date               : 2026-03-18
 * Description        : Short Description (manual edit required)
 * 
 * Copyright (C) Innovative Design Labs, Inc. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * This file is subject to the terms and conditions defined in
 * file 'IDL_BACKGROUNDTECH_LICENSE.txt', which is part of this source code package.
 */

import { Output } from "../publishers/output.model"

export class Publisher {
    pubId: number
    pubIdx: number
    numOutputs: number
    accessTypes: number
    expectedPeriod: number
    name: string = ""
    outputs: Output[] = []

    constructor(pubId: number, pubIdx: number, numOutputs: number, accessTypes: number, expectedPeriod: number) {
        this.pubId = pubId
        this.pubIdx = pubIdx
        this.numOutputs = numOutputs
        this.accessTypes = accessTypes
        this.expectedPeriod = expectedPeriod
    }

    asObject(): any {
        return {
            accessTypes: this.accessTypes,
            expPeriod: this.expectedPeriod,
            name: this.name,
            numOutputs: this.numOutputs,
            pubId: this.pubId,
            pubIdx: this.pubIdx,
            outputs: []
        }
    }
}